import { useRef } from 'react';
import { FileText, Upload, X } from 'lucide-react';
import { toast } from 'sonner';

const MAX_FILES = 3;
const MAX_SIZE = 2 * 1024 * 1024;

const DocumentsUploadSection = ({ pendingFiles, setPendingFiles }) => {
  const inputRef = useRef(null);

  const addFiles = (fileList) => {
    const files = Array.from(fileList || []);
    const next = [...pendingFiles];
    for (const f of files) {
      if (next.length >= MAX_FILES) {
        toast.error(`Massimo ${MAX_FILES} documenti per appuntamento`);
        break;
      }
      if (f.size > MAX_SIZE) {
        toast.error(`"${f.name}" supera i 2 MB`);
        continue;
      }
      next.push(f);
    }
    setPendingFiles(next);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div className="border border-gray-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-semibold text-gray-700 flex items-center gap-2">
          <FileText size={16} className="text-lojack-red" /> Documenti
        </p>
        {pendingFiles.length < MAX_FILES && (
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="flex items-center gap-1.5 text-sm text-blue-600 hover:text-blue-800 font-medium"
            data-testid="new-appointment-upload-btn"
          >
            <Upload size={14} /> Carica Documento
          </button>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.jpg,.jpeg,.png,.gif,.webp,.zip"
        className="hidden"
        onChange={(e) => addFiles(e.target.files)}
        data-testid="new-appointment-file-input"
      />
      {pendingFiles.length === 0 ? (
        <p className="text-xs text-gray-400">
          Nessun documento selezionato — PDF, Immagini, Doc, Excel (max 2MB) — verranno allegati al salvataggio
        </p>
      ) : (
        <div className="space-y-1.5">
          {pendingFiles.map((f, idx) => (
            <div key={idx} className="flex items-center justify-between bg-gray-50 rounded px-3 py-1.5 text-sm" data-testid={`pending-file-${idx}`}>
              <span className="text-gray-700 truncate">{f.name} <span className="text-gray-400 text-xs">({Math.ceil(f.size / 1024)} KB)</span></span>
              <button
                type="button"
                onClick={() => setPendingFiles(pendingFiles.filter((_, i) => i !== idx))}
                className="text-gray-400 hover:text-red-600 ml-2"
                data-testid={`pending-file-remove-${idx}`}
              >
                <X size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DocumentsUploadSection;
